import { jsx, jsxs } from "react/jsx-runtime";
import { useTranslations, useLanguage } from "@vocab/react";
import { useThemeName, Card, Stack, Heading, Columns, Column, TextField, Button, Box } from "braid-design-system";
import { useState } from "react";
import { translations } from "./.vocab/index.mjs";
import * as Apollo from "@apollo/client";
import { gql } from "@apollo/client";
const defaultOptions = {};
const ValidatePromoCodeDocument = gql`
    query ValidatePromoCode($input: ValidatePromoCodeInput!) {
  validatePromoCode(input: $input) {
    isValid
    message
  }
}
    `;
function useValidatePromoCodeLazyQuery(baseOptions) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery(ValidatePromoCodeDocument, options);
}
const HirerPromoCodesInput = ({
  productId,
  bannerToDisplay,
  onClick,
  onError,
  onInvalid,
  onSuccess,
  onClear
}) => {
  const [validatePromoCode, { loading }] = useValidatePromoCodeLazyQuery({
    onError: (error) => {
      onError(error);
      setErrorMessage(error.message);
    },
    onCompleted: (data) => {
      if (!data.validatePromoCode.isValid) {
        onInvalid(data.validatePromoCode.message, promoCode);
        setErrorMessage(data.validatePromoCode.message);
        return;
      }
      onSuccess(promoCode);
      setErrorMessage(void 0);
    }
  });
  const [promoCode, setPromoCode] = useState("");
  const [errorMessage, setErrorMessage] = useState(
    void 0
  );
  const { t } = useTranslations(translations);
  const { locale } = useLanguage();
  const theme = useThemeName();
  const validatePromoCodeHandler = () => {
    if (!promoCode) {
      setErrorMessage(t("promo-code-input-empty-textField-text"));
      return;
    }
    if (promoCode.length > 64) {
      setErrorMessage(t("promo-code-invalid-input-error-text"));
      return;
    }
    if (onClick) {
      onClick(promoCode);
    }
    validatePromoCode({
      variables: { input: { promoCode, productId, locale } }
    });
  };
  return theme === "apac" ? (
    // Apac theme
    /* @__PURE__ */ jsx(Card, { children: /* @__PURE__ */ jsxs(Stack, { space: "medium", children: [
      /* @__PURE__ */ jsx(Heading, { level: "3", children: t("promo-code-input-heading-text") }),
      Boolean(bannerToDisplay) && bannerToDisplay,
      /* @__PURE__ */ jsxs(Columns, { collapseBelow: "tablet", space: "medium", children: [
        /* @__PURE__ */ jsx(Column, { width: "4/5", children: /* @__PURE__ */ jsx(
          TextField,
          {
            "aria-label": t("promo-code-input-placeholder-text"),
            disabled: loading,
            id: "promoCodeInput",
            message: errorMessage,
            onChange: (e) => {
              setPromoCode(e.currentTarget.value.trim());
              setErrorMessage(void 0);
            },
            onClear: () => {
              setPromoCode("");
              setErrorMessage(void 0);
              onClear();
            },
            placeholder: t("promo-code-input-placeholder-text"),
            tone: errorMessage ? "critical" : "neutral",
            value: promoCode ?? "",
            clearLabel: t("promo-code-input-clear-field-button-text")
          }
        ) }),
        /* @__PURE__ */ jsx(Column, { children: /* @__PURE__ */ jsx(
          Button,
          {
            loading,
            onClick: () => {
              validatePromoCodeHandler();
            },
            children: t("promo-code-input-apply-button-text")
          }
        ) })
      ] })
    ] }) })
  ) : (
    // seekJobs theme
    /* @__PURE__ */ jsxs(Box, { children: [
      /* @__PURE__ */ jsxs(Stack, { space: "medium", children: [
        /* @__PURE__ */ jsx(Heading, { level: "4", children: t("promo-code-input-heading-text") }),
        Boolean(bannerToDisplay) && /* @__PURE__ */ jsx(Columns, { space: "medium", children: /* @__PURE__ */ jsx(Column, { width: "4/5", children: bannerToDisplay }) })
      ] }),
      /* @__PURE__ */ jsx(Box, { paddingTop: Boolean(bannerToDisplay) ? "small" : "medium", children: /* @__PURE__ */ jsxs(Columns, { collapseBelow: "tablet", space: "medium", children: [
        /* @__PURE__ */ jsx(Column, { width: "4/5", children: /* @__PURE__ */ jsx(Stack, { space: "small", children: /* @__PURE__ */ jsx(
          TextField,
          {
            "aria-label": t("promo-code-input-placeholder-text"),
            disabled: loading,
            id: "promoCodeInput",
            message: errorMessage,
            onChange: (e) => {
              setPromoCode(e.currentTarget.value.trim());
              setErrorMessage(void 0);
            },
            onClear: () => {
              setPromoCode("");
              setErrorMessage(void 0);
              onClear();
            },
            placeholder: t("promo-code-input-placeholder-text"),
            tone: errorMessage ? "critical" : "neutral",
            value: promoCode ?? "",
            clearLabel: t("promo-code-input-clear-field-button-text")
          }
        ) }) }),
        /* @__PURE__ */ jsx(Column, { width: "content", children: /* @__PURE__ */ jsx(
          Button,
          {
            tone: "formAccent",
            variant: "solid",
            loading,
            onClick: () => {
              validatePromoCodeHandler();
            },
            children: t("promo-code-input-apply-button-text")
          }
        ) })
      ] }) })
    ] })
  );
};
export {
  HirerPromoCodesInput
};
